import React, { useEffect, useRef } from 'react';
import { translate } from '../Services/translation';

const Popup = ({
    product,
    onClose,
    onGoToCart,
    rightStrength,
    leftStrength,
    rightCurve,
    leftCurve,
    rightDiameter,
    leftDiameter,
    rightCylinder,
    leftCylinder,
    rightAxis,
    leftAxis,
    rightEyeAdd,
    leftEyeAdd,
    rightColor,
    leftColor,
    rightPacket,
    leftPacket,
    checkoutUrl
}) => {
    const popupRef = useRef(null);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const hasLeftEyeValues = leftStrength || leftCurve || leftDiameter || leftCylinder || leftAxis || leftColor || leftEyeAdd || leftPacket;
    const hasRightEyeValues = rightStrength || rightCurve || rightDiameter || rightCylinder || rightAxis || rightColor || rightEyeAdd || rightPacket;

    return (
        <div className="add-to-cart-pop-up">
            <div className="add-to-cart-pop-up__content" ref={popupRef}>
                <div className='add-to-cart-pop-up__top-wrapper'>
                    <h2 className='add-to-cart-pop-up__title'>
                        {translate('coptikk.product.addedtocart')}
                    </h2>
                    <div className='add-to-cart-pop-up__close' onClick={onClose}></div>
                </div>
                <div className="add-to-cart-pop-up__product">
                    <figure className="add-to-cart-pop-up__product-image">
                        {product.image[0] && <a
                            data-src={product.image[0].src}
                            href="#"
                            className="image"
                            dangerouslySetInnerHTML={{
                                __html: product.image[0].html,
                            }}
                        ></a>}
                    </figure>
                    <div className="add-to-cart-pop-up__product-info">
                        <p className="add-to-cart-pop-up__product-name">{product.name}</p>
                        {hasRightEyeValues &&
                            <div className="add-to-cart-pop-up__product-spec-wrapper">
                                <div className="eye-spec">
                                    <b>{translate('coptikk.product.righteye')}: </b>
                                    <div className='spec-row'>
                                        <p>{rightStrength}</p>
                                        {rightCurve && rightCurve !== "0" && (<p>{translate('coptikk.product.curve.short')}: {rightCurve}</p>)}
                                        {rightDiameter && rightDiameter !== "0" && (<p>{translate('coptikk.product.diameter.short')}: {rightDiameter}</p>)}
                                        {rightCylinder && rightCylinder !== "0" && (<p>{translate('coptikk.product.cylinder.short')}: {rightCylinder}</p>)}
                                        {rightAxis && rightAxis !== "0" && (<p>{translate('coptikk.product.axis')}: {rightAxis}</p>)}
                                        {rightEyeAdd && (<p>{translate('coptikk.product.addfield')}: {rightEyeAdd}</p>)}
                                        {rightColor && (<p>{translate('coptikk.product.color')}: {rightColor}</p>)}
                                    </div>
                                </div>
                                <div className="eye-spec">
                                    <b>{translate('coptikk.product.packets')}: </b>
                                    <p>{rightPacket} {translate('coptikk.price.unit')} {product.basePrice},-</p>
                                </div>
                            </div>
                        }
                        {hasLeftEyeValues &&
                            <div className="add-to-cart-pop-up__product-spec-wrapper">
                                <div className="eye-spec">
                                    <b>{translate('coptikk.product.lefteye')}: </b>
                                    <div className='spec-row'>
                                        <p>{leftStrength}</p>
                                        {leftCurve && leftCurve !== "0" && (<p>{translate('coptikk.product.curve.short')}: {leftCurve}</p>)}
                                        {leftDiameter && leftDiameter !== "0" && (<p>{translate('coptikk.product.diameter.short')}: {leftDiameter}</p>)}
                                        {leftCylinder && leftCylinder !== "0" && (<p>{translate('coptikk.product.cylinder.short')}: {leftCylinder}</p>)}
                                        {leftAxis && leftAxis !== "0" && (<p>{translate('coptikk.product.axis')}: {leftAxis}</p>)}
                                        {leftEyeAdd && (<p>{translate('coptikk.product.addfield')}: {leftEyeAdd}</p>)}
                                        {leftColor && (<p>{translate('coptikk.product.color')}: {leftColor}</p>)}
                                    </div>
                                </div>
                                <div className="eye-spec">
                                    <b>{translate('coptikk.product.packets')}: </b>
                                    <p>{leftPacket} {translate('coptikk.price.unit')} {product.basePrice},-</p>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="add-to-cart-pop-up__buttons-wrapper">
                    <a className="cart" onClick={onGoToCart} href={checkoutUrl}>{translate('coptikk.product.to.checkout')}</a>
                    <button className="continue" onClick={onClose}>{translate('coptikk.product.continue')}</button>
                </div>
            </div>
        </div>
    );
};

export default Popup;